import { createContext, Dispatch } from 'react';

import { Clip, CollectionResponse } from '../../types';

export type State = {
  isSearching: boolean;
  results: Array<Clip>;
  isLoading: boolean;
  searchTotal: number;
  searchPage: number;
  hasErrored: boolean;
  searchText: string;
};

type CloseSearchAction = {
  type: 'CLOSE_SEARCH';
};

type SetPageSize = {
  type: 'SEARCH_PAGE';
  payload: number;
};

type SearchSuccessAction = {
  type: 'SEARCH_SUCCESS';
  payload: CollectionResponse<Clip>;
};

type StartSearchAction = {
  type: 'START_SEARCH';
};

type SearchTextAction = {
  type: 'SEARCH_TEXT';
  payload: string;
};

type SearchErrorAction = {
  type: 'SEARCH_ERROR';
};

export type Action =
  | CloseSearchAction
  | SearchSuccessAction
  | StartSearchAction
  | SearchTextAction
  | SetPageSize
  | SearchErrorAction;

export const AlbumManagementDispatcher = createContext<Dispatch<Action>>(() => {
  throw new Error('Not implemented');
});

/**
 * Simple reducer for managing the state of the order of elements.
 */
export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SEARCH_SUCCESS':
      return {
        ...state,
        isLoading: false,
        searchTotal: action.payload.total,
        searchPage: action.payload.page,
        results: action.payload.data,
      };
    case 'CLOSE_SEARCH':
      return {
        ...state,
        isSearching: false,
        isLoading: true,
      };
    case 'START_SEARCH':
      return {
        ...state,
        isSearching: true,
        isLoading: true,
        hasErrored: false,
      };
    case 'SEARCH_ERROR':
      return {
        ...state,
        isLoading: false,
        hasErrored: true,
      };
    case 'SEARCH_PAGE':
      return {
        ...state,
        isLoading: true,
        searchPage: action.payload,
      };
    case 'SEARCH_TEXT':
      return {
        ...state,
        searchText: action.payload,
      };
    default:
      return state;
  }
}
